import ScrollPolyFill from 'smoothscroll-polyfill';
ScrollPolyFill.polyfill();
export var Scroll;
(function (Scroll) {
    function scrollIntoView(selector, delay) {
        const nextElement = document.querySelector(selector);
        if (nextElement) {
            setTimeout(() => {
                nextElement.scrollIntoView({ behavior: 'smooth' });
            }, delay);
        }
    }
    Scroll.scrollIntoView = scrollIntoView;
})(Scroll || (Scroll = {}));
